/**
 * Central Event Definitions for Realtime Communication
 * Unified across all transports (SignalR, uWebSockets, Native WebSockets)
 */

export const ServerEvents = Object.freeze({
    ONLINE_USERS: "ONLINE_USERS",
    SEND_NOTIFICATION: "SEND_NOTIFICATION",
    SEND_UPDATE_PAGE: "SEND_UPDATE_PAGE",
});

export const ClientMethods = Object.freeze({
    REGISTER_USER: "RegisterUser",
    GET_ONLINE_USERS: "GetOnlineUsers",
    USER_LOGOUT: "UserLogout",
    SET_PAGE_TITLE: "SetPageTitle",
    SEND_EMAIL: "SendEmail",
    SHARE_FILE: "ShareFile",
    SHARE_LESSON: "ShareLesson",
    SHARE_MISSION: "ShareMission",
    NOTIFICATION_IS_VIEW: "NotificationIsView",
    SEND_CONTACT_US: "SendContactUs",
    SCHOOL_REGISTER: "SchoolRegister",
    ERROR_REPORT: "ErrorReport",
    ERROR_REPORT_IS_SOLVE: "ErrorReportIsSolve",
    UPDATE_GAME_SCORE: "UpdateGameScore",
});

export const NotificationTypes = Object.freeze({
    NEW_EMAIL: "NEW_EMAIL",
    SHARE_LESSON: "SHARE_LESSON",
    SHARE_FILE: "SHARE_FILE",
    SHARE_MISSION: "SHARE_MISSION",
    NOTIFICATION_ISVIEW: "NOTIFICATION_ISVIEW",
    SEND_CONTACTUS: "SEND_CONTACTUS",
    SCHOOL_REGISTER: "SCHOOL_REGISTER",
    ERROR_REPORT: "ERROR_REPORT",
    ERROR_REPORT_IS_SOLVE: "ERROR_REPORT_IS_SOLVE",
});

export const ConnectionState = Object.freeze({
    DISCONNECTED: "DISCONNECTED",
    CONNECTING: "CONNECTING",
    CONNECTED: "CONNECTED",
    RECONNECTING: "RECONNECTING",
});
